if (!customElements.get('zayix-browsing-tools')) {
  class ZayixBrowsingTools extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-search-bar]');
      this.topButton = this.querySelector('[data-back-top]');
      this.floatingTools = this.querySelector('[data-floating-tools]');
      this.cartCount = this.querySelector('[data-cart-count]');
      this.syncCartCount = () => {
        const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        const text = bubble?.querySelector('[aria-hidden="true"]')?.textContent || bubble?.textContent || '0';
        const count = Number(text.match(/\d+/)?.[0] || 0);
        this.cartCount.textContent = String(count);
        this.cartCount.hidden = count === 0;
      };
      this.cartObserver = new MutationObserver(this.syncCartCount);
      const icons = document.querySelector('.header__icons');
      if (icons) this.cartObserver.observe(icons, { childList: true, subtree: true, characterData: true });
      this.syncCartCount();
      this.header = document.querySelector('.section-header');
      this.controller = new AbortController();
      this.update = () => {
        const active = window.scrollY > 600;
        const headerBottom = this.header?.getBoundingClientRect().bottom || 0;
        this.bar.style.top = Math.max(0, headerBottom) + 'px';
        this.bar.hidden = !active;
        this.topButton.hidden = !active;
        this.floatingTools.hidden = !active;
      };
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true, signal: this.controller.signal });
      window.addEventListener('resize', this.onScroll, { passive: true, signal: this.controller.signal });
      this.header?.addEventListener('transitionend', this.onScroll, { signal: this.controller.signal });
      this.topButton.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const heading = document.querySelector('main h1');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
      }, { signal: this.controller.signal });
      this.update();
      this.setupScope?.();
    }
    disconnectedCallback() {
      this.cartObserver?.disconnect();
      this.searchController?.abort();
      this.searchObserver?.disconnect();
      document.documentElement.classList.remove('zayix-scoped-active');
      this.controller?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('zayix-browsing-tools', ZayixBrowsingTools);
}


/* Description links reveal the destination collection's products. */
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.collection-hero__description a[href], .zayix-all-collection a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !/\/collections\/[^/]+/.test(destination.pathname) || destination.hash) return;
    destination.hash = 'product-grid';
    link.href = destination.href;
  });
  const revealProducts = () => {
    if (location.hash !== '#product-grid') return;
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const first = document.querySelector('.facets-vertical-sort') || grid.querySelector('li') || grid;
    const header = document.querySelector('.section-header');
    const offset = Math.max(0, header?.getBoundingClientRect().height || 0) + 110;
    window.scrollTo({ top: Math.max(0, first.getBoundingClientRect().top + window.scrollY - offset), behavior: 'instant' });
    grid.setAttribute('tabindex', '-1');
    grid.setAttribute('data-zayix-scroll-target', '');
    grid.focus({ preventScroll: true });
  };
  if (document.readyState === 'complete') requestAnimationFrame(revealProducts);
  else window.addEventListener('load', () => requestAnimationFrame(revealProducts), { once: true });
  window.addEventListener('hashchange', revealProducts);
})();
